import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppSettings } from '../../proyect.conf';
import { ProductosEstadosRelacionesTiposPreaprobados } from '../_models/productos-estados-relaciones-tipos-preaprobados';
import { AutenticacionService } from './autenticacion.service';

@Injectable({
  providedIn: 'root'
})
export class ProductosEstadosRelacionesTiposPreaprobadosService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosEstadosRelacionesTiposPreaprobados';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) {
  }

  listado() {
    return this.httClient.get(`${this.rutServicio}`).pipe(map(resp => resp as ProductosEstadosRelacionesTiposPreaprobados[]))
  }

  listadoHabilitado() {
    return this.httClient.get(`${this.rutServicio}/enabled`).pipe(map(resp => resp as ProductosEstadosRelacionesTiposPreaprobados[]))
  }

  obtenerPorId(id: string) {
    return this.httClient.get(`${this.rutServicio}/${id}`).pipe(map(resp => resp as ProductosEstadosRelacionesTiposPreaprobados))
  }

  listadoPorProductoEstadoRelacionId(idProductoEstadoRelacion: string) {
    return this.httClient.get(`${this.rutServicio}/${idProductoEstadoRelacion}`).pipe(map(resp => resp as ProductosEstadosRelacionesTiposPreaprobados[]))
  }

  listadoPorProductoEstadoRelacionIdHabilitados(idProductoEstadoRelacion: string) {
    return this.httClient.get(`${this.rutServicio}/${idProductoEstadoRelacion}/enabled`).pipe(map(resp => resp as ProductosEstadosRelacionesTiposPreaprobados[]))
  }

  listadoPorProductoId(idProducto: string) {
    return this.httClient.get(`${this.rutServicio}/productos/${idProducto}`).pipe(map(resp => resp as ProductosEstadosRelacionesTiposPreaprobados[]))
  }

  listadoPorProductoEstadoRelacionIn(idsProductoEstadoRelacion: string[]) {
    return this.httClient.post(`${this.rutServicio}/productosEstadosRelaciones/in/enabled`, idsProductoEstadoRelacion).pipe(map(resp => resp as ProductosEstadosRelacionesTiposPreaprobados[]));
  }

  crear(data: ProductosEstadosRelacionesTiposPreaprobados) {
    data.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post(`${this.rutServicio}`, data).pipe(map(resp => resp as ProductosEstadosRelacionesTiposPreaprobados))
  }

  actualizar(data: ProductosEstadosRelacionesTiposPreaprobados) {
    data.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put(`${this.rutServicio}`, data).pipe(map(resp => resp as ProductosEstadosRelacionesTiposPreaprobados))
  }

  crearLista(data: ProductosEstadosRelacionesTiposPreaprobados[]) {
    data.map(d => {
      d.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
      return d;
    })
    return this.httClient.post(`${this.rutServicio}/bulk`, data).pipe(map(resp => resp as ProductosEstadosRelacionesTiposPreaprobados))
  }
}
